<template>
  <div class="shouhu">
    <!-- 头部 -->
    <div class="header">
      <van-nav-bar fixed>
        <!-- <img class="img" slot="left" src="@/assets/m-logo.png" alt=""> -->
        <div class="left" slot="left">
          <img class="img" src="@/assets/my-logo.png" alt="">
          <h1 class="gs">长沙巨鸿信息科技有限公司</h1>
        </div>
        <span class="callme" slot="right" @click="show = true">联系我们</span>
      </van-nav-bar>
    </div>
    <healthy />
    <addictedGames />
    <whychoose />
    <situationdisplay />
    <shouhufooter></shouhufooter>
    <!-- 底部 -->
    <div class="foot">
      <van-tabbar fixed>
        <van-cell>
          <template #title>
            <div class="title-left">
              <img class="img" slot="icon" src="@/assets/my-logo.png" alt="">
              <h3 class="gs">长沙巨鸿信息科技有限公司</h3>
            </div>

          </template>
          <!-- <img class="img" slot="icon" src="@/assets/my-logo.png"> -->

          <van-button class="foot-download" size="normal" :url="url">
            <i slot="icon" class="iconfont icon-anzhuo"></i>
            立即下载
          </van-button>
        </van-cell>
      </van-tabbar>
    </div>
    <!-- 联系弹出层 -->
    <van-popup v-model="show" round>
      <callme @close="show = false" />
    </van-popup>
    <!-- /联系弹出层 -->
  </div>
</template>

<script>

import healthy from '@/views/components/healthy.vue'
import addictedGames from '@/views/components/addictedGames.vue'
import whychoose from '@/views/components/whyChoose.vue'
import situationdisplay from '@/views/components/situationDisplay.vue'
import shouhufooter from '@/views/components/shouhufooter.vue'
import callme from '@/views/components/callme.vue'
import { url } from '@/data/index'
export default {
  data() {
    return {
      show: false,
      url: url
    }
  },
  methods: {},
  components: {
    healthy,
    addictedGames,
    whychoose,
    situationdisplay,
    shouhufooter,
    callme
  }
}
</script>

<style scoped>
.shouhu {
  position: relative;
}

.header {
  height: 46px;
}

.header .left {
  display: flex;
  align-items: center;
  justify-content: center;
}

.gs {
  font-size: 15px;
  margin-left: 5px;
}

.img {
  /* width: 150px;
  height: 46px; */
  width: 30px;
  height: 30px;
}

.callme {
  font-size: 16px;
}

.van-button {
  height: 35px;
}

.van-button__content {
  height: 35px;
  color: #fff;
}

.van-cell .van-cell__value--alone {
  text-align: right;
  color: #fff;
}

.van-cell {
  height: 50px;
  padding: 0;
}

.foot {
  width: 100%;
  height: 50px;
}

.foot .title-left {
  display: flex;
  align-items: center;
  justify-content: center;
}

.foot .title-left .img {
  width: 35px;
  height: 35px;
  margin-bottom: 5px;
}

.foot .title-left .gs {
  font-size: 12px;
}

.foot-download {
  border-radius: 8px;
  background-color: #18c2d0;
  margin: 8px 15px;
  font-size: 16px;

}

.icon-anzhuo {
  font-size: 18px;
}

.popup {
  width: 300px;
  height: 300px;
  border-radius: 10px;
}
</style>
